import React from 'react';
import PropTypes from 'prop-types';
import {defaultTemplate} from 'core/hoc';
import {DatePicker} from 'core/components';
import moment from 'moment';
import { observable } from "mobx";

class DatePickerFilterTemplate extends React.Component {
    @observable accessor value;

    constructor(props) {
        super(props);

        this.queryUtility = props.queryUtility;
        this.propertyName = props.propertyName;
    }

    onValueChange = (event) => {
        this.value = event;
        this.queryUtility.filter.set(this.propertyName, moment.tz(event,"UTC").format("YYYY-MM-DD"));
    }

    render() {
        const {
            t,
            label
        } = this.props;

        return <React.Fragment>
            <div className='iputgroup'>
                <div className='form__group__label'>{t(label)}</div>
                <DatePicker
                    value={this.value}
                    onChange={this.onValueChange}
                />
                
            </div>
            
        </React.Fragment>;
    }
}

DatePickerFilterTemplate.propTypes = {
    queryUtility: PropTypes.object,
    propertyName: PropTypes.string,
    placeholder: PropTypes.string,
    clearVisible: PropTypes.bool,
    t: PropTypes.func,
    label: PropTypes.string
};

DatePickerFilterTemplate.defaultProps = {
    propertyName: 'date',
    placeholder: 'Select date',
    clearVisible: false,
    label: 'Date'
};

export default defaultTemplate(DatePickerFilterTemplate);
